import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal, type Type, inject } from '@angular/core';
import { TopProgressService } from '@modules/top-progress/top-progress.service';

/**
 * The History tab's {@link SheetVersionHistoryComponent}, loaded when the tab is first shown rather than with the app:
 * the workbook form is in the initial bundle, which History took over its 15 MB budget (SBUX-1146 review). Not
 * `@defer`, which would have brought in Angular's defer runtime (7 kB, more than the tab itself); `ngComponentOutlet`
 * is in the bundle already.
 */
@Component({
  selector: 'app-sheet-version-history-lazy',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
  template: `<ng-container *ngComponentOutlet="component(); inputs: inputs()" />`,
})
export class SheetVersionHistoryLazyComponent {
  public readonly workbookId = input.required<string>();
  public readonly revision = input<number | undefined>(undefined);
  public readonly readOnly = input(false);
  public readonly tenantId = input<string | undefined>(undefined);

  protected readonly component = signal<Type<unknown> | null>(null);
  protected readonly inputs = computed(() => ({
    workbookId: this.workbookId(),
    revision: this.revision(),
    readOnly: this.readOnly(),
    tenantId: this.tenantId(),
  }));

  constructor() {
    void inject(TopProgressService)
      .track(import('./sheet-version-history.component'))
      .then(({ SheetVersionHistoryComponent }) => this.component.set(SheetVersionHistoryComponent));
  }
}
